/* */ 
"use strict";
var core_1 = require('@angular/core');
var exceptions_1 = require('../../facade/exceptions');
var collection_1 = require('../../facade/collection');
exports.EVENT_MANAGER_PLUGINS = new core_1.OpaqueToken("EventManagerPlugins");
var EventManager = (function() {
  function EventManager(plugins, _zone) {
    var _this = this;
    this._zone = _zone;
    plugins.forEach(function(p) {
      return p.manager = _this;
    });
    this._plugins = collection_1.ListWrapper.reversed(plugins);
  }
  EventManager.prototype.addEventListener = function(element, eventName, handler) {
    var plugin = this._findPluginFor(eventName);
    return plugin.addEventListener(element, eventName, handler);
  };
  EventManager.prototype.addGlobalEventListener = function(target, eventName, handler) {
    var plugin = this._findPluginFor(eventName);
    return plugin.addGlobalEventListener(target, eventName, handler);
  };
  EventManager.prototype.getZone = function() {
    return this._zone;
  };
  EventManager.prototype._findPluginFor = function(eventName) {
    var plugins = this._plugins;
    for (var i = 0; i < plugins.length; i++) {
      var plugin = plugins[i];
      if (plugin.supports(eventName)) {
        return plugin;
      }
    }
    throw new exceptions_1.BaseException("No event manager plugin found for event " + eventName);
  };
  EventManager.decorators = [{type: core_1.Injectable}];
  EventManager.ctorParameters = [{
    type: undefined,
    decorators: [{
      type: core_1.Inject,
      args: [exports.EVENT_MANAGER_PLUGINS]
    }]
  }, {type: core_1.NgZone}];
  return EventManager;
}());
exports.EventManager = EventManager;
var EventManagerPlugin = (function() {
  function EventManagerPlugin() {}
  EventManagerPlugin.prototype.supports = function(eventName) {
    return false;
  };
  EventManagerPlugin.prototype.addEventListener = function(element, eventName, handler) {
    throw "not implemented";
  };
  EventManagerPlugin.prototype.addGlobalEventListener = function(element, eventName, handler) {
    throw "not implemented";
  };
  return EventManagerPlugin;
}());
exports.EventManagerPlugin = EventManagerPlugin;
